import { Component, Input, OnInit } from '@angular/core';
import { WorkshopRegistrationRequestModel } from '../../models/workshop-registration-request.model';
import { PersianTitlesService } from '../../../core/services/persian-titles.service';
import { CommonModule } from '@angular/common';
import { NgIconComponent } from '@ng-icons/core';
import {
  SharedWorkshopCardComponent,
  SharedWorkshopCardAction,
  SharedWorkshopCardRow,
} from 'src/app/shared/components/shared-workshop-card/shared-workshop-card.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-workshop-registration-request-card',
  templateUrl: './workshop-registration-request-card.component.html',
  styleUrls: ['./workshop-registration-request-card.component.css'],
  standalone: true,
  imports: [CommonModule, SharedWorkshopCardComponent, TranslateModule],
})
export class WorkshopRegistrationRequestCardComponent implements OnInit {
  @Input('workshopRegistrationRequest')
  request!: WorkshopRegistrationRequestModel;

  // Labels
  teacherLabel: string = '';
  holdingTypeLabel: string = '';
  holdingDateLabel: string = '';
  locationLabel: string = '';
  daysLeftLabel: string = '';
  requestDateLabel: string = '';
  statusLabel: string = '';

  cardActions: SharedWorkshopCardAction[] = [];
  cardRows: SharedWorkshopCardRow[] = [];

  constructor(
    private persianTitlesService: PersianTitlesService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.initLabel();
    this.initRows();
    this.initActions();
  }

  private initLabel() {
    this.teacherLabel = this.persianTitlesService.Items.Teacher;
    this.holdingDateLabel = this.persianTitlesService.Items.HoldingDate;
    this.holdingTypeLabel = this.persianTitlesService.Items.HoldingType;
    this.locationLabel = this.persianTitlesService.Items.Location;
    this.requestDateLabel = this.persianTitlesService.Items.RequestDate;
    this.statusLabel = this.persianTitlesService.Items.RegistrationStatus;
    this.daysLeftLabel = this.persianTitlesService.Items.DaysLeft;
  }

  private initRows() {
    this.cardRows = [
      {
        icon: 'lucideUser',
        title: this.teacherLabel,
        value: this.request.workshop.teacherFullName,
      },
      {
        icon: 'lucideCalendar',
        title: this.holdingDateLabel,
        value: this.request.workshop.holdingDateJalali,
      },
      {
        icon: 'lucideLayers',
        title: this.holdingTypeLabel,
        value: this.request.workshop.holdingTypeTitle,
      },
      {
        icon: 'lucideClipboardList',
        title: this.requestDateLabel,
        value: this.request.registrationDateJalali,
      },
    ];

    let statusBadge = '';
    let badgeColor = 'warning';
    if (this.request.status === 1) {
      statusBadge = this.translateService.instant(
        'trainingHist.labels.pending',
      );
    } else if (this.request.status === 2) {
      statusBadge = this.translateService.instant(
        'trainingHist.labels.approved',
      );
      badgeColor = 'success';
    } else if (this.request.status === 3) {
      statusBadge = this.translateService.instant(
        'trainingHist.labels.rejected',
      );
      badgeColor = 'danger';
    } else if (this.request.status === 4) {
      statusBadge = this.translateService.instant(
        'trainingHist.labels.expired',
      );
    }
    this.cardRows.push({
      icon: '',
      title: '',
      value: '',
      badge: statusBadge,
      badgeColor,
    });
  }

  private initActions() {
    this.cardActions = [];
  }
}
